import React from 'react'
import { useNavigate } from 'react-router-dom'
import SubNavbar from './ui/SubNavbar'

export default function AdminEventsNavbar({ selected, has_accommodation, has_transportation }) {
  const navigate = useNavigate()
  const event_id = new URLSearchParams(window.location.search).get("event_id")
  const state = new URLSearchParams(window.location.search).get("state")
  const activeState = state || selected || "general"

  const allTabs = [
    { id: "general", label: "General", active: true },
    { id: "accommodation", label: "Accommodation", active: has_accommodation == "1" && event_id !== "new" },
    { id: "registration", label: "Registration", active: event_id !== "new" },
    { id: "forms", label: "Forms", active: event_id !== "new" },
    { id: "waitlist", label: "Waitlist", active: event_id !== "new" },
    { id: "check-ins", label: "Check-Ins", active: event_id !== "new" },
  ].filter(t => t.active)

  return (
    <div className="mb-4">
      <SubNavbar
        tabs={allTabs}
        activeTab={activeState}
        onTabChange={(tabId) => {
          navigate(`/admin/events/details?state=${tabId}&event_id=${event_id}`)
        }}
      />
    </div>
  )
}
